// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: '14947c1e-b5b0-46a6-a42f-6b7409acdef0',
      type: 'Container',
      name: 'root',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: {
        dynamicValues: {
          y: 'height * -0.5'
        }
      }
    },
    {
      id: '9fca876b-1f61-4760-8d2d-0b501183b070',
      type: 'Sprite',
      name: 'overlay',
      className: 'dynamicProps_SPL',
      x: 0,
      y: -500,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 12.1875,
        y: 20
      },
      angle: 0,
      alpha: 0.8,
      visible: true,
      tint: 0,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'square_64',
      parent: '14947c1e-b5b0-46a6-a42f-6b7409acdef0',
      data: {
        dynamicValues: {
          width: 'width * 2',
          height: 'height * 2'
        }
      }
    },
    {
      id: '1fb2fe34-c2be-4418-b19d-3ec2ca096a95',
      type: 'Sprite',
      name: '',
      className: '',
      x: 1000,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'MOCK_VS_result_lose',
      parent: '14947c1e-b5b0-46a6-a42f-6b7409acdef0',
      data: {
        DEBUG: true
      }
    },
    {
      id: '719f0e7c-db71-41be-acea-467883b85c5b',
      type: 'Container',
      name: 'popup',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '14947c1e-b5b0-46a6-a42f-6b7409acdef0',
      data: {
        dynamicValues: {
          y: 'height * 0.5'
        }
      }
    },
    {
      id: '43f21bf1-0826-4f3d-9dd5-b86f8a25132d',
      type: 'Container',
      name: 'logo',
      className: '',
      x: 0,
      y: -483,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '719f0e7c-db71-41be-acea-467883b85c5b'
    },
    {
      id: 'd7c24091-fb1c-4400-ad20-dd8af42db88d',
      type: 'Container',
      name: 'ribbonContainers',
      className: '',
      x: 0,
      y: -311,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '719f0e7c-db71-41be-acea-467883b85c5b'
    },
    {
      id: '4a1c1d8e-fdc9-4456-a047-732531f88529',
      type: 'Sprite',
      name: 'crownPlayer',
      className: '',
      x: 194,
      y: -98,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_resultScreen_crown',
      parent: '719f0e7c-db71-41be-acea-467883b85c5b',
      stateByName: {
        playerWon: {
          x: -206,
          y: -117
        }
      }
    },
    {
      id: '85ab73e3-9fad-42d7-a03a-37033e59defe',
      type: 'Container',
      name: 'playerContainer',
      className: '',
      x: -206,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '719f0e7c-db71-41be-acea-467883b85c5b'
    },
    {
      id: '519a3ca1-3eb3-418c-9a68-5bf95e65b24b',
      type: 'Container',
      name: 'enemyContainer',
      className: '',
      x: 194,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '719f0e7c-db71-41be-acea-467883b85c5b'
    },
    {
      id: 'dc2297fc-2f9b-4347-bd42-25c8584244fa',
      type: 'Container',
      name: 'vsContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '719f0e7c-db71-41be-acea-467883b85c5b'
    },
    {
      id: '918c4002-118c-4fbf-9b1e-fcef3395f255',
      type: 'Container',
      name: 'rewardContainer',
      className: '',
      x: 194,
      y: 198,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '719f0e7c-db71-41be-acea-467883b85c5b',
      stateByName: {
        playerWon: {
          x: -206
        }
      }
    },
    {
      id: '1870d53c-c0d2-4d02-a19d-2934462d9115',
      type: 'Text',
      name: 'continueButton',
      className: '',
      x: 0,
      y: 395,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -2000,
        y: -2000,
        width: 4000,
        height: 4000
      },
      text: 'Tap to continue',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '719f0e7c-db71-41be-acea-467883b85c5b'
    },
    {
      id: '3d145281-abda-43fd-b30c-c9c2973fd741',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 79,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2.426724,
        y: 1.646552
      },
      angle: 0,
      alpha: 0.4,
      visible: true,
      tint: 16711680,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: '43f21bf1-0826-4f3d-9dd5-b86f8a25132d',
      stateByName: {
        playerWon: {
          visible: false
        }
      }
    },
    {
      id: '6a821b5c-bb43-4d64-b6ba-5af2e5aa7110',
      type: 'Sprite',
      name: '',
      className: 'rotate_SPL',
      x: 6,
      y: 44,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 0.4,
      visible: true,
      tint: 16082689,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_rays',
      parent: '43f21bf1-0826-4f3d-9dd5-b86f8a25132d'
    },
    {
      id: '2fc5a296-05b7-4064-a618-815295d8a131',
      type: 'Sprite',
      name: '',
      className: '',
      x: -95,
      y: -22,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_matchPopup_piece01',
      parent: '43f21bf1-0826-4f3d-9dd5-b86f8a25132d'
    },
    {
      id: 'bd54d6f9-ac0d-4d62-bcee-f0910a5712ff',
      type: 'Sprite',
      name: '',
      className: '',
      x: 132,
      y: 9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 14.5,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_matchPopup_piece03',
      parent: '43f21bf1-0826-4f3d-9dd5-b86f8a25132d'
    },
    {
      id: '2dd43899-d2e6-482a-b1f4-9580bda18e7f',
      type: 'Sprite',
      name: '',
      className: '',
      x: -110,
      y: 43,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.55,
        y: 0.55
      },
      angle: 8.6,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_matchPopup_piece02',
      parent: '43f21bf1-0826-4f3d-9dd5-b86f8a25132d'
    },
    {
      id: '1e0cc239-662e-4238-9296-ece72ce8378e',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 22,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.55,
        y: 0.55
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_matchPopup_logo',
      parent: '43f21bf1-0826-4f3d-9dd5-b86f8a25132d'
    },
    {
      id: '635c0124-4a5e-4fdb-8534-821fe9a63e4a',
      type: 'Container',
      name: 'playerWonContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'd7c24091-fb1c-4400-ad20-dd8af42db88d',
      stateByName: {
        playerWon: {
          visible: true
        }
      }
    },
    {
      id: 'f3bc97e7-4b86-4ca6-b60e-0e7751d26ebc',
      type: 'Container',
      name: 'enemyWonContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'd7c24091-fb1c-4400-ad20-dd8af42db88d',
      stateByName: {
        playerWon: {
          visible: false
        }
      }
    },
    {
      id: '18c5d6f7-a870-47e2-a311-da89d8f3fb5f',
      type: 'Sprite',
      name: '',
      className: 'rotate_SPL',
      x: -3,
      y: 2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16082689,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_rays',
      parent: '85ab73e3-9fad-42d7-a03a-37033e59defe',
      stateByName: {
        playerWon: {
          visible: true
        }
      }
    },
    {
      id: 'ac4fb9a9-5c55-4de1-9889-2123fa5361e7',
      type: 'Sprite',
      name: 'playerAvatar',
      className: 'userAvatar_SPL',
      x: -53,
      y: -112,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2.12,
        y: 2.12
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'avatar_placeholder',
      parent: '85ab73e3-9fad-42d7-a03a-37033e59defe'
    },
    {
      id: 'b57b539b-dd69-4857-99e7-66856d8f4434',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.05,
        y: 1.05
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Player_Leaderboard_Frame',
      parent: '85ab73e3-9fad-42d7-a03a-37033e59defe'
    },
    {
      id: '612fd1d2-dac1-46dc-93f3-a7fa5f227153',
      type: 'Text',
      name: '',
      className: 'variable_SPL',
      x: 0,
      y: 35,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '<player.name>',
      localize: false,
      maxWidth: 164,
      maxHeight: 77,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '#5F151A',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#5F151A',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '85ab73e3-9fad-42d7-a03a-37033e59defe'
    },
    {
      id: '2b7b484d-8214-4b48-a9bf-e95ed6016557',
      type: 'Container',
      name: '',
      className: 'centerChildren_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '85ab73e3-9fad-42d7-a03a-37033e59defe',
      data: {
        centerChildrenPadding: 10
      }
    },
    {
      id: '29bbe4fd-c30b-49e8-b7ce-c6efe5864f01',
      type: 'Sprite',
      name: '',
      className: 'rotate_SPL',
      x: 0,
      y: 20,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.65,
        y: 0.65
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16082689,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_rays',
      parent: '519a3ca1-3eb3-418c-9a68-5bf95e65b24b',
      stateByName: {
        playerWon: {
          visible: false
        }
      }
    },
    {
      id: 'a70f2f0c-10f1-4e39-883d-c5148944ca70',
      type: 'Sprite',
      name: 'enemyAvatar',
      className: 'insertAvatar_SPL',
      x: -45,
      y: -99,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.8,
        y: 1.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'avatar_placeholder',
      parent: '519a3ca1-3eb3-418c-9a68-5bf95e65b24b',
      data: {
        insertAvatar_SPL: 'versus.enemy'
      }
    },
    {
      id: '84a9dc69-3101-431c-a961-823967b59532',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.15,
        y: 1.15
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Friends_Leaderboard_Frame',
      parent: '519a3ca1-3eb3-418c-9a68-5bf95e65b24b'
    },
    {
      id: '073474e2-de38-4ffb-9d0c-226d3d9562b3',
      type: 'Text',
      name: '',
      className: 'variable_SPL',
      x: 0,
      y: 30,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '<versus.enemyName>',
      localize: false,
      maxWidth: 139,
      maxHeight: 77,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '#5F151A',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#5F151A',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '519a3ca1-3eb3-418c-9a68-5bf95e65b24b'
    },
    {
      id: 'f121b689-0873-4648-a6a7-b824af8a4939',
      type: 'Container',
      name: '',
      className: 'centerChildren_SPL',
      x: 0,
      y: -13,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '519a3ca1-3eb3-418c-9a68-5bf95e65b24b',
      data: {
        centerChildrenPadding: 10
      }
    },
    {
      id: '5eecc15c-ec17-4255-bedd-77125a3534cc',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: -24.6,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_matchPopup_bolt',
      parent: 'dc2297fc-2f9b-4347-bd42-25c8584244fa'
    },
    {
      id: '2ec9acfe-a24d-46cf-8f61-3ab612e4f1c5',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_matchPopup_vs',
      parent: 'dc2297fc-2f9b-4347-bd42-25c8584244fa'
    },
    {
      id: '29f2590c-7bb7-4c64-a0f8-9497092fec18',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_coin_reward',
      parent: '918c4002-118c-4fbf-9b1e-fcef3395f255'
    },
    {
      id: '40879f19-6add-4d3b-a781-c6b8881b9f53',
      type: 'Container',
      name: '',
      className: 'centerChildren_SPL',
      x: 0,
      y: 22,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '918c4002-118c-4fbf-9b1e-fcef3395f255',
      data: {
        centerChildrenPadding: 10
      }
    },
    {
      id: 'ac4eb3e6-d8c1-4e4d-9c7d-572d1c061dbf',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_banner_2',
      parent: '635c0124-4a5e-4fdb-8534-821fe9a63e4a'
    },
    {
      id: '58f7ffaf-8d06-4bf8-b82a-04524d86e17c',
      type: 'Text',
      name: '',
      className: 'curvedText_SPL',
      x: 0,
      y: -40,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'YOU WIN!',
      localize: true,
      maxWidth: 467,
      maxHeight: 113,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 55,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#39066B',
        strokeThickness: 10,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '635c0124-4a5e-4fdb-8534-821fe9a63e4a',
      data: {
        curveRadius: 1300,
        translations: {
          en_US: 'YOU WIN!',
          it_IT: 'VINCI!',
          fr_FR: 'TU GAGNES !',
          de_DE: 'DU GEWINNST!',
          es_ES: '¡GANAS!',
          pt_PT: 'GANHAS!',
          pl_PL: 'WYGRYWASZ!',
          nl_NL: 'JE WINT!',
          ko_KR: '이기고 있다!',
          ja_JP: '勝っている！'
        }
      }
    },
    {
      id: '8b057478-0359-472e-ba70-d497c94a2581',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_banner_1',
      parent: 'f3bc97e7-4b86-4ca6-b60e-0e7751d26ebc'
    },
    {
      id: 'f77a1c9e-0249-42aa-86e1-7433c3b55c01',
      type: 'Text',
      name: '',
      className: 'curvedText_SPL',
      x: 0,
      y: -40,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'YOU LOSE',
      localize: true,
      maxWidth: 467,
      maxHeight: 113,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 55,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#7C0B2B',
        strokeThickness: 10,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'f3bc97e7-4b86-4ca6-b60e-0e7751d26ebc',
      data: {
        curveRadius: 1300,
        translations: {
          en_US: 'YOU LOSE',
          it_IT: 'PERDI',
          fr_FR: 'TU PERDS',
          de_DE: 'DU VERLIERST',
          es_ES: 'PIERDES',
          pt_PT: 'PERDES',
          pl_PL: 'PRZEGRYWASZ',
          nl_NL: 'JE VERLIEST',
          ko_KR: '지고 있다',
          ja_JP: '負けている'
        }
      }
    },
    {
      id: 'f9e933ca-2741-42d1-8d5f-d6b083129fe2',
      type: 'Text',
      name: '',
      className: '',
      x: -17,
      y: 100,
      anchor: {
        x: 0.5,
        y: 1
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Lvl',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 3,
        dropShadowColor: '#7C180C',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '2b7b484d-8214-4b48-a9bf-e95ed6016557'
    },
    {
      id: '52870590-c889-4fde-a0a4-0ed5c43bc5ed',
      type: 'Text',
      name: '',
      className: 'variable_SPL',
      x: 26,
      y: 101,
      anchor: {
        x: 0.5,
        y: 1
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '<player.level>',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 3,
        dropShadowColor: '#7C180C',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '2b7b484d-8214-4b48-a9bf-e95ed6016557'
    },
    {
      id: '8cbb5866-6da6-47e2-a91a-d0b9a1245599',
      type: 'Text',
      name: '',
      className: '',
      x: -17,
      y: 100,
      anchor: {
        x: 0.5,
        y: 1
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Lvl',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 3,
        dropShadowColor: '#7C180C',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'f121b689-0873-4648-a6a7-b824af8a4939'
    },
    {
      id: '96e16194-412e-45d5-887d-d46168cedb69',
      type: 'Text',
      name: '',
      className: 'variable_SPL',
      x: 26,
      y: 101,
      anchor: {
        x: 0.5,
        y: 1
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '<versus.enemyLevel>',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 3,
        dropShadowColor: '#7C180C',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'f121b689-0873-4648-a6a7-b824af8a4939'
    },
    {
      id: '5011c672-56bf-4359-b98e-85ab5c395799',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'coin',
      parent: '40879f19-6add-4d3b-a781-c6b8881b9f53'
    },
    {
      id: '502155e1-8f25-4c92-bd35-f4922e11aab2',
      type: 'Text',
      name: '',
      className: 'variable_SPL',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '<versus.reward>',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 46,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#FBE750',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '40879f19-6add-4d3b-a781-c6b8881b9f53'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '4.0.1',
  stateNames: [
    'playerWon'
  ],
  animations: [
    {
      id: '87e746f3-d5db-4ca0-b00f-d82a3400820a',
      name: 'Appear',
      playingSpeed: 1,
      totalDuration: 1900,
      blocks: [
        {
          id: 'ee089ead-0c20-4acb-9602-42b16b05bd0c',
          type: 'Setter',
          name: 'New_setter',
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'overlay',
          disabled: false
        },
        {
          id: '247a2dd6-64d7-4573-bc7e-7df182625e7c',
          type: 'Setter',
          name: 'ribbonContainers',
          track: 7,
          target: {
            scale: {
              x: 0
            }
          },
          startAt: 0,
          sourceName: 'ribbonContainers',
          disabled: false
        },
        {
          id: 'd0433a64-f6aa-4719-87c1-53383829773f',
          type: 'Setter',
          name: 'enemyContainer',
          track: 5,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'enemyContainer',
          disabled: false
        },
        {
          id: '8c054513-103f-4dad-aac6-401bcda40625',
          type: 'Setter',
          name: 'playerContainer_1',
          track: 6,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'playerContainer',
          disabled: false
        },
        {
          id: '3b9dfcb7-2f7e-404c-967b-0b5712e89dc4',
          type: 'Setter',
          name: 'vsContainer',
          track: 4,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'vsContainer',
          disabled: false
        },
        {
          id: '91eb432e-c08c-42e9-bc2b-b299a921d1b8',
          type: 'Setter',
          name: 'logo',
          track: 8,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'logo',
          disabled: false
        },
        {
          id: 'ab941306-e56d-4231-b7a1-7c63a0bed5df',
          type: 'Setter',
          name: 'rewardContainer_1',
          track: 3,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'rewardContainer',
          disabled: false
        },
        {
          id: '50cae859-e5a7-4946-a803-28bd8b888452',
          type: 'Setter',
          name: 'SET_crownPlayer',
          track: 9,
          target: {
            anchor: {},
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'crownPlayer',
          disabled: false
        },
        {
          id: '70dda05a-0f56-4bd1-b83d-956f9212b94e',
          type: 'Setter',
          name: 'SET_continueButton',
          track: 10,
          target: {
            scale: {
              x: 0,
              y: 0
            },
            alpha: 0
          },
          startAt: 0,
          sourceName: 'continueButton',
          disabled: false
        },
        {
          id: '5749255a-1fbc-4e07-8b26-6ffeb3f8d311',
          type: 'Tween',
          name: 'overlay',
          duration: 300,
          track: 2,
          target: {
            alpha: 0.8
          },
          startAt: 1,
          sourceName: 'overlay',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: 'dabcfa68-cd68-4a6a-a7eb-54aa111b8813',
          type: 'Tween',
          name: 'logo_tween',
          duration: 458,
          track: 8,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 132,
          sourceName: 'logo',
          easing: 'ElasticOut',
          disabled: false
        },
        {
          id: 'd5c3c784-f66d-4eb4-bc8c-ef4ac9f57e6b',
          type: 'Tween',
          name: 'TWEEN_vsContainer',
          duration: 500,
          track: 4,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 174,
          sourceName: 'vsContainer',
          easing: 'ElasticOut',
          disabled: false
        },
        {
          id: '78790c98-305d-4d44-9f2f-741884007645',
          type: 'Tween',
          name: 'TWEEN_playerContainer',
          duration: 300,
          track: 6,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 219.29999999981374,
          sourceName: 'playerContainer',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: '668e994d-1e45-4350-be9f-cc609adf0960',
          type: 'Tween',
          name: 'TWEEN_enemyContainer',
          duration: 300,
          track: 5,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 296,
          sourceName: 'enemyContainer',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: '516810ad-f9e6-458b-b6dd-cbbccd088f7d',
          type: 'Tween',
          name: 'TWEEN_ribbonContainers',
          duration: 450,
          track: 7,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 600,
          sourceName: 'ribbonContainers',
          easing: 'CubicOut',
          disabled: false
        },
        {
          id: 'd6f5b3dd-c3f7-4566-bf48-d40fc18d8dfd',
          type: 'Tween',
          name: 'TWEEN_crownPlayer',
          duration: 500,
          track: 9,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 769,
          sourceName: 'crownPlayer',
          easing: 'ElasticOut',
          disabled: false
        },
        {
          id: '7b004a60-73a0-45ff-b7b2-d1defe8b278d',
          type: 'Tween',
          name: 'TWEEN_rewardContainer',
          duration: 500,
          track: 3,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 815,
          sourceName: 'rewardContainer',
          easing: 'ElasticOut',
          disabled: false
        },
        {
          id: '235300d3-d73f-44bd-8628-9bcdc88706dd',
          type: 'Setter',
          name: 'SET_continueButton_1',
          track: 10,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1598,
          sourceName: 'continueButton',
          disabled: false
        },
        {
          id: '68538bc9-96dc-487e-b67b-31080b790a7d',
          type: 'Tween',
          name: 'TWEEN_continueButton',
          duration: 300,
          track: 10,
          target: {
            alpha: 1
          },
          startAt: 1598,
          sourceName: 'continueButton',
          easing: 'Linear',
          disabled: false
        }
      ]
    },
    {
      id: 'f935ec51-3176-4438-8d3a-101f1f6975a7',
      name: 'Idle',
      playingSpeed: 1,
      totalDuration: 1400,
      blocks: [
        {
          id: 'f6fa8704-41b2-4c15-8e73-67e54f17f8bf',
          type: 'Tween',
          name: 'TWEEN_continueButton_1',
          duration: 700,
          track: 2,
          target: {
            alpha: 0.5
          },
          startAt: 0,
          sourceName: 'continueButton',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: 'befcaea2-74cf-42c1-aa3a-447ddc8f2c64',
          type: 'Tween',
          name: 'TWEEN_continueButton_1_copy',
          duration: 700,
          track: 2,
          target: {
            alpha: 1
          },
          startAt: 700,
          sourceName: 'continueButton',
          easing: 'SinusoidalInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class VersusResultPopupLayout {
  static raw = raw;
  root!: Container & { data: typeof raw['list'][0]['data'] };
  overlay!: Sprite & { data: typeof raw['list'][1]['data'] };
  popup!: Container & { data: typeof raw['list'][3]['data'] };
  logo!: Container;
  ribbonContainers!: Container;
  crownPlayer!: Sprite;
  playerContainer!: Container;
  enemyContainer!: Container;
  vsContainer!: Container;
  rewardContainer!: Container;
  continueButton!: Text;
  playerWonContainer!: Container;
  enemyWonContainer!: Container;
  playerAvatar!: Sprite;
  enemyAvatar!: Sprite & { data: typeof raw['list'][26]['data'] };
  dynamicProps_SPL!: (Container & { data: typeof raw['list'][0]['data'] } | Sprite & { data: typeof raw['list'][1]['data'] } | Container & { data: typeof raw['list'][3]['data'] })[];
  rotate_SPL!: (Sprite)[];
  userAvatar_SPL!: (Sprite)[];
  variable_SPL!: (Text)[];
  centerChildren_SPL!: (Container & { data: typeof raw['list'][24]['data'] } | Container & { data: typeof raw['list'][29]['data'] } | Container & { data: typeof raw['list'][33]['data'] })[];
  insertAvatar_SPL!: (Sprite & { data: typeof raw['list'][26]['data'] })[];
  curvedText_SPL!: (Text & { data: typeof raw['list'][35]['data'] } | Text & { data: typeof raw['list'][37]['data'] })[];
  StateName!: 'playerWon';

  constructor() {
    populate(this, raw);
  }
}

export abstract class Appear {
  Layout: {
    overlay: object;
    ribbonContainers: object;
    enemyContainer: object;
    playerContainer: object;
    vsContainer: object;
    logo: object;
    rewardContainer: object;
    crownPlayer: object;
    continueButton: object;
  };

  BlockTypeByName: {
    New_setter: object;
    ribbonContainers: object;
    enemyContainer: object;
    playerContainer_1: object;
    vsContainer: object;
    logo: object;
    rewardContainer_1: object;
    SET_crownPlayer: object;
    SET_continueButton: object;
    overlay: object;
    logo_tween: object;
    TWEEN_vsContainer: object;
    TWEEN_playerContainer: object;
    TWEEN_enemyContainer: object;
    TWEEN_ribbonContainers: object;
    TWEEN_crownPlayer: object;
    TWEEN_rewardContainer: object;
    SET_continueButton_1: object;
    TWEEN_continueButton: object;
  };

  flowData = raw.animations[0];
}

export abstract class Idle {
  Layout: {
    continueButton: object;
  };

  BlockTypeByName: {
    TWEEN_continueButton_1: object;
    TWEEN_continueButton_1_copy: object;
  };

  flowData = raw.animations[1];
}
